import { lazy } from 'react';
import { EnumBehaviorKey } from 'src/types/Behaviors';
import { AppRoute } from 'src/types/Route';

// const ChatSearch = lazy(
//   () =>
//     import(
//       /* webpackChunkName: "ChatSearch" */ 'src/pages/Backstage/subPages/AiManage/ChatSearch'
//     ),
// );

const ModelSet = lazy(
  () =>
    import(
      /* webpackChunkName: "ModelSet" */ 'src/pages/Backstage/subPages/AiManage/ModelSet'
    ),
);

const ModelChannel = lazy(
  () =>
    import(
      /* webpackChunkName: "ModelChannel" */ 'src/pages/Backstage/subPages/AiManage/ModelChannel'
    ),
);

// const TrackSet = lazy(
//   () =>
//     import(
//       /* webpackChunkName: "TrackSet" */ 'src/pages/Backstage/subPages/AiManage/TrackSet'
//     ),
// );

const UseLog = lazy(
  () =>
    import(
      /* webpackChunkName: "UseLog" */ 'src/pages/Backstage/subPages/AiManage/UseLog'
    ),
);

const BusinessKnowledge = lazy(
  () =>
    import(
      /* webpackChunkName: "BusinessKnowledge" */ 'src/pages/Backstage/subPages/AiManage/BusinessKnowledge'
    ),
);

const ThinkConfig = lazy(
  () =>
    import(
      /* webpackChunkName: "ThinkConfig" */ 'src/pages/Backstage/subPages/AiManage/ThinkConfig'
    ),
);

const EntityAnalyzer = lazy(
  () =>
    import(
      /* webpackChunkName: "EntityAnalyzer" */ 'src/pages/Backstage/subPages/AiManage/EntityAnalyzer'
    ),
);

const EditDataset = lazy(
  () =>
    import(
      /* webpackChunkName: "AIEditDataset" */ 'src/pages/Backstage/subPages/AiManage/EntityAnalyzer/subPages/dataset/EditDataset'
    ),
);

const aiManageRoutes: AppRoute[] = [
  // {
  //   name: '会话查询',
  //   path: '/backstage/ai-manage/chat-search',
  //   Component: ChatSearch,
  // },
  {
    name: '模型渠道',
    path: '/backstage/ai-manage/model-channel',
    Component: ModelChannel,
    behaviors: [EnumBehaviorKey.MODEL_RESOURCE_MANAGE],
  },
  {
    name: '模型配置',
    path: '/backstage/ai-manage/model-set',
    Component: ModelSet,
    behaviors: [EnumBehaviorKey.MODEL_RESOURCE_MANAGE],
  },
  // {
  //   name: '思路配置',
  //   path: '/backstage/ai-manage/track-set',
  //   Component: TrackSet,
  // },
  {
    name: '调用日志',
    path: '/backstage/ai-manage/use-log',
    Component: UseLog,
    behaviors: [EnumBehaviorKey.MODEL_RESOURCE_MANAGE],
  },
  {
    name: '业务知识',
    path: '/backstage/ai-manage/business-knowledge',
    Component: BusinessKnowledge,
    behaviors: [EnumBehaviorKey.AGENT_PERFORMANCE_OPTIMIZE],
  },
  {
    name: '思路配置',
    path: '/backstage/ai-manage/think-config',
    Component: ThinkConfig,
    behaviors: [EnumBehaviorKey.AGENT_PERFORMANCE_OPTIMIZE],
  },
  {
    name: '实体检测查询',
    path: '/backstage/ai-manage/entity-analyzer',
    Component: EntityAnalyzer,
    behaviors: [EnumBehaviorKey.AGENT_PERFORMANCE_OPTIMIZE],
  },
  {
    name: '编辑数据集',
    path: '/backstage/ai-manage/edit-dataset',
    Component: EditDataset,
    hideInPanel: true,
    behaviors: [EnumBehaviorKey.AGENT_PERFORMANCE_OPTIMIZE],
  },
];

export default aiManageRoutes;
